import { Form, Input } from "antd";

export default function Caption(props) {
  return (
    <Form.Item {...props} name="image_caption">
      <Input className="w-full" placeholder="Enter image caption (optional)" />
    </Form.Item>
  );
}
